import React, {useEffect, useRef} from 'react';

const ConditionalContainerPlugin = () => {
  return {
    Renderer: (props) => {
      return <>
        {props.children}
      </>
    },

    id: 'conditional-container-plugin',
    title: 'Conditional Container',
    description: 'Container which is shown conditionally',
    version: 1,
    controls: {
      type: 'autoform',
      schema: {
        properties: {
          liquid_show_expression: {
            type: 'string',
            default: 'false',
          },
        },
        required: ['liquid_show_expression'],
      },
    },
  }
}

export default ConditionalContainerPlugin